import { useContext, useEffect } from "react";
import { askConfirmation, mayDecline } from "common/AskConfirmation";
import { updateCommand } from "./api";
import { checkNothingPending } from "views/Config/Profiles/Common/Settings";
import ActionsContext from "common/ActionsContext";
const runBatch = (command) => ifCl.run(command, /*is batch*/ true);

const enableInterface = (name) =>
  runBatch(updateCommand(name, { enable: true }));

const disableInterface = (name, actions) =>
  askConfirmation(
    `Disable "${name}" interface?`,
    `You are about to disable the interface "${name}" and take it down. ` +
      "If the interface is part of a wire, traffic will be interrupted. " +
      "Are you sure?",
    { icon: "warning", actions }
  ).then(() => runBatch(updateCommand(name, { disable: true })));

const updateInterface = ({ enable, disable, name }, actions) =>
  checkNothingPending().then(
    () =>
      new Promise((resolve, reject) =>
        enable === true
          ? resolve(enableInterface(name))
          : disable === true
          ? resolve(disableInterface(name, actions))
          : reject(`No operation to update ${name}`)
      )
  );

const reportError = (error) => window.showModalError("Failed", String(error));

const HandleEnableOrDisable = () => {
  const actions = useContext(ActionsContext);
  useEffect(
    () =>
      actions.recv("show-interface-update", (params) =>
        updateInterface(params, actions)
          .then(() => actions.send('do-load'))
          .catch(mayDecline)
          .catch(reportError)
      ),
    []
  );
  return null;
}

export default HandleEnableOrDisable;
